module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tooltipText || _vm.theCurrentWidth > 1024) ? _c('div', {
    staticClass: "u-d-flex",
    class: {
      'u-r-flex-wrap': _vm.isRouteByName('mini-calculators')
    }
  }, [_c('div', {
    staticClass: "c-icon-tooltip__container",
    class: [_vm.tooltipName, _vm.iconType],
    style: ({
      width: _vm.containerWidth + _vm.pixelOrPercent
    }),
    on: {
      "mouseover": _vm.iconEnter,
      "mouseleave": _vm.iconLeave
    }
  }, [(!_vm.noIcon && _vm.tooltipText) ? _c('svg', {
    staticClass: "m-icon m-icon--small m-icon--no-hover open",
    class: _vm.iconColour,
    style: (_vm.hoverStyle),
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.iconType
    }
  })]) : _c('svg', {
    staticClass: "m-icon m-icon--small m-icon--no-hover open",
    class: _vm.iconColour,
    style: (_vm.hoverStyle),
    attrs: {
      "focusable": "false",
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.iconType
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tooltipVisible),
      expression: "tooltipVisible"
    }],
    staticClass: "c-icon-tooltip__text",
    class: 'c-icon-tooltip__' + _vm.side,
    style: ({
      width: _vm.textWidth + 'px'
    })
  }, [_vm._v("\n            " + _vm._s(_vm.tooltipText) + "\n        ")]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "c-icon-tooltip__responsive-text"
  }, [_vm._v(_vm._s(_vm.tooltipText))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cc604f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconTooltip.vue
// module id = 1597
// module chunks = 0